import React from "react";
import Layout from "../Layout";
import Form from "./form";
import useApi from "Hooks/Admin/useApi";
import useAuth from "Hooks/Admin/useAuth";
import useError from "Hooks/useError";
import { message } from "constants/message";
import { withRouter } from "react-router";

function Type(props) {
  const { params } = props.match;
  const typeId = parseInt(params.typeId, 10);

  const { request } = useApi();
  const auth = useAuth();
  const stateError = useError();
  const messages = message();
  const [type, setType] = React.useState(null);

  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder Admin - メディア仕分け更新";
  }, []);

  React.useEffect(() => {
    if (!auth.state.token) {
      return;
    }
    fetchType();
  }, [auth.state.token]);

  const fetchType = () => {
    request({
      method: "GET",
      url: `admin/media/types/${typeId}`,
    }).then((result) => {
      const data = {
        label: result.data.data.label,
        sources: result.data.data.sources,
        color: result.data.data.color,
      }

      setType(data);
    });
  }

  const handleSubmit = (type) => {
    let data = {
      label: type.label,
      sources: (type.sources.split("\n")).filter(Boolean),
      color: type.color
    };

    request({
      method: "PUT",
      url: `admin/media/types/${typeId}`,
      data: data,
    })
      .then((data) => {
        stateError.initialize();
        props.history.push("/admin/media/types?success=edit");
      })
      .catch((error) => {
        stateError.dispatch({
          type: "set",
          payload: {
            isError: true,
            errorMsg: messages.validation.common,
          },
        });
      });
    return
  };

  return (
    <Layout
      content={
        <Form
          submit={handleSubmit}
          type={type}
          isEdit={true}
        />
      }
    />
  );
}
export default withRouter(Type);
